import request from '@/utils/request';

export function querySysMakerSwitchPage(query) {
  return request({
    url: '/api/system/sysMakerSwitch/querySysMakerSwitchPage',
    method: 'post',
    data: query
  });
}

export function querySysMakerSwitchList(query) {
  return request({
    url: '/api/system/sysMakerSwitch/querySysMakerSwitchList',
    method: 'post',
    data: query
  });
}

export function updateSysMakerSwitch(form) {
  return request({
    url: '/api/system/sysMakerSwitch/updateSysMakerSwitch',
    method: 'post',
    data: form
  });
}

export function saveSysMakerSwitch(form) {
  return request({
    url: '/api/system/sysMakerSwitch/saveSysMakerSwitch',
    method: 'post',
    data: form
  });
}

export function deleteSysMakerSwitch(id) {
  return request({
    url: '/api/system/sysMakerSwitch/deleteSysMakerSwitch',
    method: 'post',
    data: {'id': id}
  });
}

export function getSysMakerSwitch(id) {
  return request({
    url: '/api/system/sysMakerSwitch/getSysMakerSwitch',
    method: 'post',
    data: {'id': id}
  });
}

export function enable(id) {
  return request({
    url: '/api/system/sysMakerSwitch/enable',
    method: 'post',
    data: {'id': id}
  });
}

export function disable(id) {
  return request({
    url: '/api/system/sysMakerSwitch/disable',
    method: 'post',
    data: {'id': id}
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/maker.js